import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const SubscriptionStatusBanner = ({ vendorData }) => {
  const navigate = useNavigate();
  
  if (!vendorData) return null;
  
  // Calculate days since account creation
  const calculateDaysActive = () => {
    if (!vendorData.createdAt) return 0;
    const createdAt = new Date(vendorData.createdAt);
    const today = new Date();
    return Math.floor((today - createdAt) / (1000 * 60 * 60 * 24));
  };
  
  const daysActive = calculateDaysActive();
  const daysRemaining = Math.max(0, 60 - daysActive); // Changed from 30 to 60
  const hasActiveSubscription = vendorData.subscription && vendorData.subscription.status === 'ACTIVE';
  const needsSubscription = daysActive > 60 && !hasActiveSubscription; // Changed from 30 to 60
  
  // Account is in trial period
  if (daysActive <= 60 && !hasActiveSubscription) { // Changed from 30 to 60
    return (
      <Alert variant="info" className="d-flex justify-content-between align-items-center">
        <div>
          <strong>Free Trial:</strong> {daysRemaining} days remaining. Subscribe before your trial ends to maintain uninterrupted service.
        </div>
        <Button 
          variant="outline-primary" 
          size="sm" 
          onClick={() => navigate('/vendor/subscription')}
        >
          View Plans
        </Button>
      </Alert>
    );
  }
  
  // Account needs subscription (past trial period)
  if (needsSubscription) {
    return (
      <Alert variant="danger" className="d-flex justify-content-between align-items-center">
        <div>
          <strong>Subscription Required:</strong> Your account access is limited. Subscribe now to restore full functionality.
        </div>
        <Button 
          variant="primary" 
          size="sm" 
          onClick={() => navigate('/vendor/subscription')}
        >
          Subscribe Now
        </Button>
      </Alert>
    );
  }
  
  // Has active subscription
  if (hasActiveSubscription) {
    return (
      <Alert variant="success" className="d-flex justify-content-between align-items-center">
        <div>
          <strong>Active Subscription:</strong> Your account has full access to all platform features.
        </div>
        <Button 
          variant="outline-success" 
          size="sm" 
          onClick={() => navigate('/vendor/subscription')}
        >
          Manage Subscription
        </Button>
      </Alert>
    );
  }
  
  return null;
};

export default SubscriptionStatusBanner;